import $ from 'jquery';

$(function () {
    if ($('#appraisers_page').length) {

        $(document).ready(function () {

            $(":input").inputmask();
          //  $("#phone").inputmask({ "mask": "(999) 999-9999" });
            $("#phone").inputmask("(999) 999-9999", { clearIncomplete: true });
          
        });

       
        $('#email').on('input', function () {
            validateEmail(this);
        });
     
        $('#firstname').on('input', function () {
            validateFirstName(this);
        });
        $('#lastname').on('input', function () {
            validateLastName(this);
        });
        $('#company').on('input', function () {
            validateCompany(this);
        });

        function validateFirstName(input) {
            var a = input.value;
            const errorMessage = document.getElementById('error-message-firstname');
            if (a.trim().length <= 0) {
                errorMessage.textContent = 'This field is required.';
                $('#btnSaveAppraiser').prop('disabled', true);
            }
            else {
                errorMessage.textContent = '';
                $('#btnSaveAppraiser').prop('disabled', false);
            }
        
        };

        function validateLastName(input) {
            var a = input.value;
            const errorMessage = document.getElementById('error-message-lastname');
            if (a.trim().length <= 0) {
                errorMessage.textContent = 'This field is required.';
                $('#btnSaveAppraiser').prop('disabled', true);
            }
            else {
                errorMessage.textContent = '';
                $('#btnSaveAppraiser').prop('disabled', false);
            }

        };
        function validateCompany(input) {
            var a = input.value;
            const errorMessage = document.getElementById('error-message-company');
            if (a.trim().length <= 0) {
                errorMessage.textContent = 'This field is required.';
                $('#btnSaveAppraiser').prop('disabled', true);
            }
            else {
                errorMessage.textContent = '';
                $('#btnSaveAppraiser').prop('disabled', false);
            }

        };
      
        function validateEmail(input) {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const errorMessage = document.getElementById('error-message');
            if (!emailPattern.test(input.value)) {
                errorMessage.textContent = 'Invalid email format';
                $('#btnSaveAppraiser').prop('disabled', true);
            }
            else {
                errorMessage.textContent = '';
                $('#btnSaveAppraiser').prop('disabled', false);
            }
        };


        $('#btnSaveAppraiser').on('click', function (e) {

            e.preventDefault();

            if ($('#appraiser-form').valid()) {


                var form = new FormData();

                var fn = document.getElementById('firstname').value.trim();
                var ln = document.getElementById('lastname').value.trim();
                var ph = document.getElementById('phone').value
                var email = document.getElementById('email').value
                var company = document.getElementById('company').value.trim();

               
                if (fn == '' || ln == '' || ph == '' || email == '' || company == '') {
                    return false;
                }
       

                form.append("firstname", document.getElementById('firstname').value.trim());
                form.append("lastname", document.getElementById('lastname').value.trim());
                form.append("phone", document.getElementById('phone').value.trim());
                form.append("email", document.getElementById('email').value.trim());
                form.append("company", document.getElementById('company').value.trim());
               
                form.append("line1", document.getElementById('address1').value);
                form.append("line2", document.getElementById('address2').value);
                form.append("city", document.getElementById('city').value);
                form.append("state", document.getElementById('state').value);
                form.append("zip", document.getElementById('zip').value);

               
                $.ajax({
                    url: "/partners/appraisers/submit-information",
                    type: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form,
                    success: function (response) {
                        if (response == "ok") {
                            $("#modal-appraisersuccess").modal("show");
                        }
                        else {
                            $("#modal-appraiserfailure").modal("show");
                        }
                    }
                });
               
               
            }
            else {
                return false;
            }
        });

    }
});